import { render, staticRenderFns } from "./AddXiehui.vue?vue&type=template&id=2502cb98&"
import script from "./AddXiehui.vue?vue&type=script&lang=js&"
export * from "./AddXiehui.vue?vue&type=script&lang=js&"
import style0 from "./AddXiehui.vue?vue&type=style&index=0&id=2502cb98&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports